import { render, staticRenderFns } from "./OfferClaim.vue?vue&type=template&id=2382f919&scoped=true&"
import script from "./OfferClaim.vue?vue&type=script&lang=js&"
export * from "./OfferClaim.vue?vue&type=script&lang=js&"
import style0 from "./OfferClaim.vue?vue&type=style&index=0&id=2382f919&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382f919",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2382f919')) {
      api.createRecord('2382f919', component.options)
    } else {
      api.reload('2382f919', component.options)
    }
    module.hot.accept("./OfferClaim.vue?vue&type=template&id=2382f919&scoped=true&", function () {
      api.rerender('2382f919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/vitrine/OfferClaim.vue"
export default component.exports